import React from 'react';
import Card from '../Card';
import './MetricCard.css';

export default function MetricCard({ title, value, subtitle, icon, trend, trendLabel, colorClass = 'primary' }) {
  return (
    <Card className={`metric-card metric-card-${colorClass}`}>
      <div className="metric-content">
        <div className="metric-icon">
          {icon}
        </div>
        <div className="metric-info">
          <div className="metric-title">{title}</div>
          <div className="metric-value">{value}</div>
          {subtitle && (
            <div className="metric-subtitle">{subtitle}</div>
          )}
          {trend !== undefined && (
            <div className={`metric-trend ${trend > 0 ? 'trend-up' : trend < 0 ? 'trend-down' : 'trend-neutral'}`}>
              {trend > 0 ? '↑' : trend < 0 ? '↓' : '→'} {Math.abs(trend)}% {trendLabel || ''}
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
